var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('df-item',{attrs:{"formitem":_vm.formitem}},[_c('a-input-number',_vm._b({},'a-input-number',_vm.widgetAttrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }